module.exports = __webpack_public_path__ + "img/t5-13.3b080716.svg";